import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HeaderComponent from "./component/HeaderComponent";
import FooterComponent from "./component/FooterComponent";
import SDKUserSuccess from "./pages/SDK/SDKUserSuccess";
import SDKUserUpdate from "./pages/SDK/SDKUserUpdate";
import AuthenticationComponent from "./pages/AuthenticationComponent";
import ErrorComponent from "./component/ErrorComponent";
import AdminHeaderComponent from "./pages/Admin/AdminHeaderComponent";
import SDKUserForm from "./pages/SDK/SDKUserForm";
import AdminAuth from "./pages/Admin/AdminAuth";
import AdminReports from "./pages/Admin/AdminReports";
import AdminProfile from "./pages/Admin/AdminProfile";
import AdminNCALayerModuleRequests from "./pages/Admin/AdminNCALayerModuleRequests";
import NMUserForm from "./pages/NCALayerModule/NMUserForm";
import UserCheck from "./pages/UserCheck";
import SDKUserSelector from "./pages/SDK/SDKUserSelector";
import NMUserSuccess from "./pages/NCALayerModule/NMUserSuccess";
import GetSDKForm from "./pages/SDK/GetSDKForm";
import { useTranslation } from "react-i18next";


function MainApp() {
  const location = useLocation();
  const { i18n } = useTranslation();
  // const [language, setLanguage] = useState("ru");

  // const changeLanguage = (newLanguage) => {
  //   setLanguage(newLanguage);
  // };
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "ru"
  );

  // useEffect(() => {
  //   i18n.changeLanguage(language); // применяем язык при загрузке
  // }, [language, i18n]);
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang") || localStorage.getItem("language") || "ru";
  i18n.changeLanguage(lang);
}, [i18n]);


  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage); // сохраняем язык
    i18n.changeLanguage(newLanguage);
  };

  const isAdminPage = location.pathname.startsWith("/nm-admin");

  return (
    <>
      {isAdminPage ? (
        <AdminHeaderComponent
          language={language}
          changeLanguage={changeLanguage}
        />
      ) : (
        <HeaderComponent language={language} changeLanguage={changeLanguage} />
      )}

      <div id="body">
        <Routes>
          <Route path="/" element={<SDKUserSelector />} />
          <Route path="/success" element={<SDKUserSuccess />} />
          <Route path="/auth" element={<AuthenticationComponent />} />
          <Route path="/update-email" element={<SDKUserUpdate />} />
          <Route path="/error" element={<ErrorComponent />} />
          <Route path="/sdk-form" element={<SDKUserForm />} />
          <Route path="/get-sdk" element={<GetSDKForm />} />
          

          {/* <Route path="/nm-user-check" element={<NMUserCheck />} /> */}
          <Route path="/nm-user-form" element={<NMUserForm />} />
          <Route path="/nm-success" element={<NMUserSuccess />} />

          <Route path="/nm-admin/reports" element={<AdminReports />} />
          <Route path="/nm-auth" element={<AdminAuth />} />
          <Route path="/nm-admin/requests" element={<AdminNCALayerModuleRequests />} />
          <Route path="/nm-admin/profile" element={<AdminProfile />} />

          <Route path="/user-check" element={<UserCheck />} />

        </Routes>
      </div>
      <FooterComponent />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}

export default App;
